import { useState, useEffect } from 'react';
import { Notification } from 'src/types/Notifications';

interface PaginationState {
  page: number;
  pageSize: number;
  pageCount: number;
  paginatedNotifications: Notification[];
}

export const useNotificationPagination = (
  filteredNotifications: Notification[],
  pageSize: number = 10
): {
  paginationState: PaginationState;
  handlePageChange: (newPage: number) => void;
} => {
  const [page, setPage] = useState(1);

  // Calculate pagination values
  const pageCount = Math.ceil(filteredNotifications.length / pageSize) || 1;
  const paginatedNotifications = filteredNotifications.slice(
    (page - 1) * pageSize,
    page * pageSize
  );

  // Reset to page 1 when filtered notifications change
  useEffect(() => {
    setPage(1);
  }, [filteredNotifications.length]);

  // Ensure page is valid when pageCount changes
  useEffect(() => {
    if (page > pageCount && pageCount > 0) {
      setPage(pageCount);
    }
  }, [pageCount, page]);

  const handlePageChange = (newPage: number): void => {
    setPage(newPage);
  };

  const paginationState: PaginationState = {
    page,
    pageSize,
    pageCount,
    paginatedNotifications,
  };

  return {
    paginationState,
    handlePageChange,
  };
};
